<template>
  <div class="services-section">
    <div class="container-fluid px-0">
      <div class="services-header">
        <h2 class="services-title">MŪSŲ PASLAUGOS</h2>
        <div class="services-divider"></div>
        <p class="services-subtitle">Teikiame profesionalias žemės kasimo ir statybos paslaugas</p>
      </div>

      <div class="services-grid">
        <div class="service-card-digging">
          <div class="service-icon-wrapper-digging">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h4 class="service-title-digging">Žemės kasimas</h4>
          <p class="service-text-digging">Profesionalus žemės kasimas bet kokio sudėtingumo projektams</p>
        </div>

        <div class="service-card-digging">
          <div class="service-icon-wrapper-digging">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
            </svg>
          </div>
          <h4 class="service-title-digging">Žemės lyginimas</h4>
          <p class="service-text-digging">Tikslus sklypo lyginimas ir formavimas pagal jūsų poreikius</p>
        </div>

        <div class="service-card-digging">
          <div class="service-icon-wrapper-digging">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
            </svg>
          </div>
          <h4 class="service-title-digging">Tvenkinių kasimas</h4>
          <p class="service-text-digging">Tvenkinių ir baseinų kasimas bei formavimas</p>
        </div>

        <div class="service-card-digging">
          <div class="service-icon-wrapper-digging">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h4 class="service-title-digging">Sklypo formavimas</h4>
          <p class="service-text-digging">Sklypų formavimas ir paruošimas statybai</p>
        </div>

        <div class="service-card-digging">
          <div class="service-icon-wrapper-digging">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <h4 class="service-title-digging">Griovimo darbai</h4>
          <p class="service-text-digging">Komunikacijų ir griovių kasimas bei paruošimas</p>
        </div>

        <div class="service-card-digging">
          <div class="service-icon-wrapper-digging">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
            </svg>
          </div>
          <h4 class="service-title-digging">Technikos nuoma</h4>
          <p class="service-text-digging">Statybinės technikos ir transporto priemonių nuoma</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Services"
}
</script>

<style scoped>
.services-section {
  background: white;
  padding: 80px 20px;
}

.services-header {
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.services-title {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.services-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto 20px;
}

.services-subtitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card-digging {
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
}

.service-card-digging:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(220, 53, 69, 0.15);
  border-color: #dc3545;
}

.service-icon-wrapper-digging {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #dc3545, #ff6b6b);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.3);
  transition: all 0.3s ease;
}

.service-card-digging:hover .service-icon-wrapper-digging {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.4);
}

.service-icon-wrapper-digging svg {
  width: 40px;
  height: 40px;
  color: white;
}

.service-title-digging {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.service-text-digging {
  font-family: 'Open Sans', sans-serif;
  font-size: 0.95rem;
  line-height: 1.7;
  color: #6c757d;
  margin: 0;
}

@media (max-width: 768px) {
  .services-section {
    padding: 60px 15px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  
  .service-card-digging {
    padding: 30px 24px;
  }
}
</style>

